import React from 'react';
import './referral.scss';
import HeroNav from '../../components/mweb/HeroNav/HeroNav';
import Button from '../../components/common/Button/Button';
import Icon from '../../components/mweb/Icon/Icon';
import {
  copyPlainStringToClipboard,
  shareContent,
} from '../../hb-redux-store/util/miscellaneousServices';
import { setAppNotification } from '../../hb-redux-store/initial.action';
import { connect } from 'react-redux';
import ReferralCode from '../../components/mweb/ReferralCode/ReferralCode';
import { Link } from 'react-router-dom';
import { getReferralListing } from '../../hb-redux-store/feature/accounts/accounts.action';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import { DEFAULT_REFERRAL_AMOUNT } from 'hb-redux-store/util/constantServices';

class Referral extends React.Component {
  constructor(props) {
    super(props);
    const { referralShortLink } = props.launchInfo;
    this.referralLink = referralShortLink;
    props.getReferralListing();
  }

  getTextForSharing = () => {
    const header = '*Refer and earn*';
    const {
      referrerRewardAmount: iGet = DEFAULT_REFERRAL_AMOUNT,
      refereeRewardAmount: myFriendsGet = DEFAULT_REFERRAL_AMOUNT,
    } = this.props.referralDetails || {};
    const body =
      iGet === myFriendsGet
        ? `You and your friend get ₹${iGet} each on your successful referral`
        : `You get ₹${iGet} and your friend get ₹${myFriendsGet} on your successful referral`;
    const footer = ``;
    const shareUrl = `${header}\n\n${body}\n\n${this.referralLink}\n${footer}`;
    return shareUrl;
  };
  shareOnWhatsApp = () => {
    const shareUrl = this.getTextForSharing();
    // window.open(`whatsapp://send?text=${encodeURI(shareUrl)}`, '_blank');
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURI(shareUrl)}`,
      '_blank'
    );
  };
  shareSMS = () => {
    const shareUrl = this.getTextForSharing();
    window.open(`sms:;?body=${encodeURI(shareUrl)}`, '_blank');
  };
  openShareIntent = () => {
    const url = this.referralLink;
    const text = this.getTextForSharing();
    const title = 'Refer and earn';
    shareContent({ url, text, title })
      .then(({ message = null }) => {
        if (message) this.props.setAppNotification(message);
      })
      .catch(({ message }) => {
        if (message) this.props.setAppNotification(message);
      });
  };
  shareApps = [
    {
      icon: 'icon-referral-whatsapp',
      name: 'Whatsapp',
      onClick: this.shareOnWhatsApp,
    },
    {
      icon: 'icon-referral-fb-messenger',
      name: 'Messenger',
      onClick: this.openShareIntent,
    },
    { icon: 'icon-referral-sms', name: 'SMS', onClick: this.shareSMS },
    {
      icon: 'icon-referral-fb',
      name: 'facebook',
      onClick: this.openShareIntent,
    },
  ];
  copyCode = text => {
    copyPlainStringToClipboard(text)
      .then(({ message }) => this.props.setAppNotification(message))
      .catch(({ message }) => this.props.setAppNotification(message));
  };

  render() {
    const { referralLoading, referralDetails } = this.props;
    let referral = {
      active: false,
      title: 'Refer & Earn',
      heroImageSrc:
        'https://ik.imagekit.io/iwcam3r8ka/prod/refere/202012/7f97ad74-7e38-42a5-8d09-4b3f9fbf1b25.png',
      // 'https://ik.imagekit.io/iwcam3r8ka/assets/202007/5d874938-2dee-4bd4-8061-fb65a657cad7.png',
    };
    if (referralDetails) {
      const {
        referralActive,
        referralGuides,
        referrerRewardAmount: iGet,
        refereeRewardAmount: myFriendsGet,
        referralCode,
      } = referralDetails;
      referral = {
        active: referralActive,
        code: referralCode,
        link:
          this.referralLink ||
          `${window.location.origin}/invite/${referralCode}`,
        iGet,
        myFriendsGet,
        heroImageSrc:
          'https://ik.imagekit.io/iwcam3r8ka/prod/refere/202012/7f97ad74-7e38-42a5-8d09-4b3f9fbf1b25.png',
        // 'https://ik.imagekit.io/iwcam3r8ka/assets/202007/5d874938-2dee-4bd4-8061-fb65a657cad7.png',
        description:
          iGet === myFriendsGet
            ? `You and your friend get ₹${iGet} each on your successful referral`
            : `You get ₹${iGet} and your friend get ₹${myFriendsGet} on your successful referral`,
        instructions: referralGuides,
        title: referralActive
          ? 'Refer & Earn'
          : 'Refer & Earn offers are not available at your location. ',
      };
    }
    return (
      <div className="referral">
        <HeroNav
          navTitle={`Refer & Earn ${
            referralDetails?.totalEarned > 0
              ? `(₹${referralDetails?.totalEarned} earned)`
              : ''
          }`}
          title={referral.title}
          cleanNav={!referral.active}
          heroImageSrc={referral.heroImageSrc}
        />
        {referralLoading && <Loader />}
        {!referralLoading && (
          <React.Fragment>
            {!referral.active && (
              <div className="referral--referral-inactive">
                <div className="referral--code">
                  <div className="referral--code--content">
                    Refer & Earn is not active at your location. Keep visting to
                    know when its available.
                  </div>
                </div>
              </div>
            )}
            {referral.active && (
              <React.Fragment>
                <div className="referral--amount std-margin-lr">
                  &#8377;{referral.iGet}
                </div>
                <div className="referral--description std-margin-lr">
                  {referral.description}
                  <Link
                    to="/my/referrals/history"
                    className="button action-link more"
                  >
                    view all referrals
                  </Link>
                </div>
                <div className="referral--code">
                  <div className="referral--code--content">
                    <div className="justify-content--space-between">
                      <ReferralCode code={referral.code} />
                      <Button
                        className="button action-link referral--code--content--copy-cta"
                        onClick={() => this.copyCode(referral.code)}
                      >
                        <Icon
                          size={22}
                          class="icon-referral-copy referral--code--content--copy-cta-icon"
                        />
                        COPY CODE
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="referral--link">
                  <div className="justify-content--space-between">
                    <span>Referral Link:</span>
                    <Button
                      className="button action-link referral--code--content--copy-cta"
                      onClick={() => this.copyCode(referral.link)}
                    >
                      <Icon
                        size={22}
                        class="icon-referral-copy referral--code--content--copy-cta-icon"
                      />
                      COPY LINK
                    </Button>
                  </div>
                  <div className="referral--link--link">{referral.link}</div>
                </div>
                <div className="section-divider"></div>
                <div className="referral--share">
                  <div className="referral--title">Invite your friend with</div>
                  <div className="justify-content--space-between">
                    {this.shareApps.map((app, index) => (
                      <div className="app" key={index} onClick={app.onClick}>
                        <Icon class={`app-icon ${app.icon}`} size={40} />
                        <div className="app-name">{app.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="section-divider"></div>
                <div className="referral--instruction">
                  <div className="referral--title">How it works</div>
                  {referral.instructions.map((note, index) => (
                    <div className="referral--instruction--item" key={index}>
                      <div className="referral--instruction--item--disc"></div>
                      <div>{note}</div>
                    </div>
                  ))}
                </div>
                <div className="section-divider"></div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ initialReducer, accountsReducer }) => ({
  launchInfo: initialReducer.launchInfo,
  referralDetails: accountsReducer.referralDetails,
  referralLoading: accountsReducer.referralLoading,
});

const mapDispatchToProps = {
  setAppNotification,
  getReferralListing,
};

export default connect(mapStateToProps, mapDispatchToProps)(Referral);
